// Text messaging switch and endpoint.
// Keep TEXT_MESSAGES_ENABLED false until Twilio is connected and carrier registration is approved.
// Twilio keys live on the server function at TWILIO_ENDPOINT, never in this app.
export const TEXT_MESSAGES_ENABLED = false;
export const TWILIO_ENDPOINT = '/.netlify/functions/send-text';

// CMA client delivery (text or email with the PDF attached).
// Keep false until the server function below is connected to your text and email service.
export const CMA_DELIVERY_ENABLED = false;
export const CMA_DELIVERY_ENDPOINT = '/.netlify/functions/send-cma';
